import OperationHandler from "./OperationHandler";
import Operations from "./Operations";

const Components = [Operations, OperationHandler];

const handleAnimation = (isActive: boolean, more?: {}) => {
  return {
    transition: `all 0.5s ease-in-out`,
    clipPath: `circle(${!isActive ? `0px at 100% 50%` : "75%"})`,
    opacity: isActive ? 1 : 0,
    ...more,
  };
};

export default function Operation() {
  return (
    <>
      {Components.map((component) => {
        const Tag = component;
        return <Tag animation={handleAnimation} />;
      })}
    </>
  );
}
